import React from 'react'

const LKModalContext = React.createContext({ unwrapped: true })

export const LKModalProvider = LKModalContext.Provider

export function useLKModal() {
  return React.useContext(LKModalContext)
}
